import { render, staticRenderFns } from "./TermsAMAZSD133.vue?vue&type=template&id=59c61ac7"
import script from "./TermsAMAZSD133.vue?vue&type=script&lang=js"
export * from "./TermsAMAZSD133.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports